/**
 * Quem disse o quê na anamnese (pedido de 25/10/2026).
 *
 * "A HDA aparece como se quase tudo fossem queixas do paciente, mesmo coisas
 * ditas pelo médico, como diagnóstico." A transcrição do Ao vivo é a
 * CONVERSA inteira, sem marcar quem fala, e o pedido mandava escrever a HDA
 * "Paciente refere…" com TODOS os detalhes falados — e o servidor ainda
 * dizia que só havia um falante, o médico. O modelo juntava tudo no relato.
 *
 * A regra separa pelo conteúdo: relato (paciente/acompanhante, ou o médico
 * ditando o relato) vai na HDA; o que o médico vê, conclui, explica e decide
 * vai em exame, hipóteses e conduta. Vale pro "Prontuário" do ditado e pro
 * "Extrair Dados". Sem import de propósito: a bancada
 * (`scripts/hda-bancada.mjs`) lê este arquivo direto com o Node.
 */
export const REGRAS_QUEM_DISSE =
  'QUEM DISSE — a HDA é SÓ O RELATO. Quando a transcrição não marca quem fala, decida pelo conteúdo:\n' +
  '- É do MÉDICO e NUNCA entra na HDA nem vira "paciente refere": o que ele vê ou mede no exame (achados, ' +
  'números), o diagnóstico ou a hipótese que ele dá, a explicação da doença ou do exame, o prognóstico, as ' +
  'orientações, a prescrição e o plano ("vou pedir…", "vamos operar…", "pinga…"), e as perguntas que ele faz. ' +
  'Isso vai em "exameFisico", "hipotesesDiagnosticas" e "conduta".\n' +
  '- Pistas de fala do médico: fala COM o paciente na 2ª pessoa ("o senhor está com…", "seu olho…", "você ' +
  'tem…") ou fala DO paciente com o acompanhante ("ele tem miopia…", "ela está com…"), usa termo técnico ou ' +
  'número de exame, anuncia o que vai fazer, dita para o sistema.\n' +
  '- Pistas de fala do paciente ou do acompanhante: fala do próprio corpo em 1ª pessoa e em linguagem leiga ' +
  '("meu olho…", "eu tô vendo…", "ela reclama que…"), conta há quanto tempo, o que piora, o que já usou, o ' +
  'que outro médico disse.\n' +
  '- O médico ditando o relato ("paciente refere…", "queixa de…", "conta que…") é relato: vai na HDA.\n' +
  '- Resposta a pergunta do médico é relato: "Tem dor?" — "Não." → "Nega dor". Só escreva "nega" quando o ' +
  'paciente disse NÃO àquilo; se ele respondeu outra coisa ou não respondeu, a pergunta não vira sintoma nem ' +
  'negativa.\n' +
  '- Diagnóstico só entra na HDA quando a fala diz que ele veio de ANTES ("o outro médico falou que é ' +
  'glaucoma", "já tenho catarata" → "Refere diagnóstico prévio de glaucoma"). Sem essa marca, diagnóstico dito ' +
  'na consulta é DESTA consulta: vai só em "hipotesesDiagnosticas", e o que o médico explicou dele não vai na HDA.\n' +
  '- Na dúvida sobre quem disse, deixe fora da HDA.';
